import { gql, UnwrapGraphQLResult } from "@examspark/api";
import { parseAwsJson } from "@examspark/common";
import {
  ParsedTCMPCUnit,
  Replace,
  ResourcesItem,
  TCMPCUnitData,
  NonUndefined,
} from "@examspark/types";

export type ParsedPrintTCMPCUnit = Replace<
  NonUndefined<UnwrapGraphQLResult<typeof gql.operations.course.getUnit>>,
  {
    data: ParsedTCMPCUnit["data"];
    resources: ResourcesItem[];
    objectives: ParsedTCMPCUnit["objectives"];

    // typedGQL is doing something weird with dates
    createdAt: string | Date;
    updatedAt: string | Date;
    subUnits: never;
    type: "tcmpc";
  }
>;

export const parseTCMPCUnit = (
  draft: NonUndefined<
    UnwrapGraphQLResult<typeof gql.operations.course.getUnit>
  >,
): ParsedPrintTCMPCUnit => {
  // is there a better way to do this without the cast?
  const morph = draft as ParsedPrintTCMPCUnit;

  morph.data = parseAwsJson<TCMPCUnitData>(draft.data);

  morph.resources = draft.resources?.map((resource) => {
    if (typeof resource.data === "string") {
      resource.resource = JSON.parse(resource.data);
      resource.data = JSON.parse(resource.data);
    }
    return resource;
  });

  morph.objectives = draft.objectives?.map((objective) => {
    return objective as NonNullable<ParsedTCMPCUnit["objectives"]>[number];
  });

  return morph as ParsedPrintTCMPCUnit;
};
